import React, { Component } from 'react';
 
import AdhList from './Adhs';
//const mySql=require('../mySql/sqlServer');

var config=require('../config');
var request=require('request');
var guiUtils=require('../ApsHtmlGuiUtils');

//var md5=require("md5");
//var sha256=require("crypto-js/sha256");
//var bcrypt=require('bcryptjs');
//var sql=require("../sqlServer");


class AdhMan extends Component {
	constructor(props){
		super(props);
		this.state={adhViewedTable:[],userRank:'',sss:''};
		this.getUserRights=this.getUserRights.bind(this);
		this.trigAddUserMenu=this.trigAddUserMenu.bind(this);
		this.importAdhXlsx=this.importAdhXlsx.bind(this);
		this.exportCsv=this.exportCsv.bind(this);
		this.filterTable=this.filterTable.bind(this);
this.getAdhTable=this.getAdhTable.bind(this);
this.deleteAdh=this.deleteAdh.bind(this);

	
	}
	
    trigAddUserMenu()
	{
		window.location=config.serverAddress()+"/adhAdd";
	}
	
	getUserRights()
	{
		let self=this;
		let str=config.sqlServerAddress()+'/gRaw/getUserRights/'
		+"'"+sessionStorage.getItem("u")+"','"+sessionStorage.getItem("p")+"'";
		
		fetch(str,{
			method:'GET'}).then(function(response){
				if(response.status>=400){
					throw new Error("Bad resp");
				}
				return response.json();
			}).then(function(data){
				self.setState({userRank:data[0].rank});
				
			}).catch(err=>{console.log('caught',err);
			});		
			
	}
	
	componentDidMount()
	{
	    this.getUserRights();
		 this.getAdhTable();
	}
	importAdhXlsx()
	{
		window.location=config.serverAddress()+"/importAdhXlsx";
	}
	
	exportCsv()
	{
		let dataEx=[];
		let str=config.sqlServerAddress()+'/gRaw/getAdhList/'
			
			+
			"'"+sessionStorage.getItem("u")+"','"+sessionStorage.getItem("p")+"'";
			
			fetch(str,{
			method:'GET'}).then(function(response){
				if(response.status>=400){
					throw new Error("Bad resp");
				}
				return response.json();
			}).then(function(data){
				dataEx=data;
				let header=["id","NOM","NOM JEUNE FILLE","PRENOM","NAISSANCE","ADRESSE","COMP ADRESSE","CODE POSTAL","VILLE","TEL","email/règl. Cotis.","T","D","M","S.C.","RESPONSABLE TESTAMENT","DESTINATION CENDRES"];
				let str=guiUtils.jsonToString(data,header);
				console.log(str);
				var a=document.createElement("a");
				var file=new Blob([str],{type:'text/plain'});
				a.href=URL.createObjectURL(file);
				a.download="adherents.csv";
				a.click();
			//	self.forceUpdate();
			}).catch(err=>{console.log('caught',err);
			});
	}
	filterTable()
	{
		var tt=this.refs.filter.value;
		console.log("tt :");
		console.log(tt);
		this.setState({sss:tt});
		console.log("sss:");
		console.log(this.state.sss);
		AdhList.fil=tt;
	
		/*	
		if(tt!="")
		{
			
	        this.setState({tempTable:this.state.adhTable});
	        
			console.log(this.state.tempTable.length);
			for(var l=this.state.tempTable.length;l>=0;l--)
			{
				   let str=JSON.stringify(this.state.tempTable[l].nom);
					 if(str.includes(tt))
				    {
				    	this.state.tempTable.remove(l);
				    }				
			}	
      //      
			this.setState({adhViewedTable:this.state.tempTable});
			 * 
		}		
		else
		{
			console.log("n");
			this.setState({adhViewedTable:this.state.adhTable});
		
		}*/
	}
	getAdhTable()
    {
		let self=this;
		let str=config.sqlServerAddress()+'/gRaw/getAdhList/'
			
			+
			"'"+sessionStorage.getItem("u")+"','"+sessionStorage.getItem("p")+"'";
			
			fetch(str,{
			method:'GET'}).then(function(response){
				if(response.status>=400){
					throw new Error("Bad resp");
				}
				return response.json();
			}).then(function(data){
			//	self.setState({adhTable:data});
				self.setState({adhViewedTable:data});
				
			//	self.forceUpdate();
			}).catch(err=>{console.log('caught',err);
			});		  

    }	
	deleteAdh(adhId)
	{
		let self=this;
		let str=config.sqlServerAddress()+'/gRaw/deactivateAdh/'			
			+
			"'"+sessionStorage.getItem("u")+"','"+sessionStorage.getItem("p")+"','"+adhId+"'";
			
			fetch(str,{
			method:'GET'}).then(function(response){
				if(response.status>=400){
					throw new Error("Bad resp");
				}
				
			}).then(function(data){
				alert("Adhérent archivé avec succès");
				self.getAdhTable();
				//AdhList.forceUpdate();
				
				//window.location=config.serverAddress()+"/adh";
			}).catch(err=>{console.log('caught',err);
			});	
	}
	render()
	
	{
		let rank=this.state.userRank;
		
		if(rank=="0")
		{
			return (<div> Rang = {rank}</div>);
		}
		else if(rank=="2")
		{
			
			return (<div id="adh">
				<div id="filterLabel" class="text">Filtre</div>
			
			<input type="text" id="fff" ref="filter" onChange={this.filterTable}/><br/>
			<br/>
			
		<AdhList ref={this.AdhTable} fil={this.state.sss} deleteAdh={this.deleteAdh} getAdhTable={this.getAdhTable} data={this.state.adhViewedTable} title="Liste des Adhérents actifs" />
			<br/>
			
			<input type='button' value="Ajouter Adhérent" onClick={()=>this.trigAddUserMenu()} />
			<input type='button' value="Importer Fichier CSV" onClick={()=>this.importAdhXlsx()} />
			<input type='button' value="Exporter Fichier CSV" onClick={()=>this.exportCsv()} />
			</div>)
		;
			
		}
			else return <div>Attendre</div>;	
		
		//ReactDom.render(<PartFinderButton />,document.getElementById('_partFinderButton'));
	}
}

export default AdhMan;